import { render, staticRenderFns } from "./VerDerivacion.vue?vue&type=template&id=0e7d4c8b"
import script from "./VerDerivacion.vue?vue&type=script&lang=js"
export * from "./VerDerivacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports